export default [
  {
    name: 'goodsGroup',
    label: 'group',
    type: 'goodsGroup',
    default: {},
  },
]
